import React, { useState } from "react";
import { useMsal } from "@azure/msal-react";
import Avatar from "@mui/material/Avatar";
import CssBaseline from "@mui/material/CssBaseline";
import { CircularProgress, Button, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Microsoft } from "@mui/icons-material";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { loginRequest } from "../../../../authConfig";

const theme = createTheme();

function LoginPage() {
  const siteName = "Cam Clark Finance";
  const [loading, setLoading] = useState(false);
  const { instance } = useMsal();

  const handleLogin = () => {
    setLoading(true);
    instance.loginRedirect(loginRequest).catch((e) => {
      console.error(e);
      setLoading(false);
    });
  };

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            height: "90vh", // Make the Box fill the entire viewport height
            display: "flex", // Enable flexbox
            flexDirection: "column", // Stack children vertically
            justifyContent: "center", // Center vertically in the container
            alignItems: "center", // Center horizontally in the container
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography
            style={{ textAlign: "center" }}
            component="h1"
            variant="h5"
          >
            Cam Clark Automotive Group
          </Typography>
          <Typography
            style={{ textAlign: "center", marginTop: 16 }}
            component="h1"
            variant="h5"
          >
            {siteName}
          </Typography>
          <Button
            startIcon={<Microsoft />}
            onClick={handleLogin}
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Sign In with Microsoft
          </Button>
        </Box>
      </Container>
    </ThemeProvider>
  );
}

export default LoginPage;
